import { IssuerSubDto } from "../../types/dto";
import { get, isMockMode, simulateDelay } from "../api";

export const getSubById = (id: string): Promise<IssuerSubDto> => {
	if (isMockMode())
		return simulateDelay(50, () => ({
			features: [],
			offering: {
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			},
		})) as Promise<IssuerSubDto>;

	return get(`Subscriptions/GetById?id=${id}`);
};
